import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Partie, RequeteDetail} from '../../../entities/requete/requete.model';
import {QualityType} from './../../../entities/requete/requete.model';
import {RenameDossierComponent} from './../../rename-dossier/rename-dossier.component';
import {RequeteService} from '../../../entities/requete';
import {TrackingAction, TrackingCategory} from '../../../shared/model/tracking/tracking.enum';
import {TrackingService} from '../../../shared/services/tracking.service';
import { JhiAlertService } from 'ng-jhipster';

@Component({
    selector: 'jhi-dossier',
    templateUrl: './dossier.component.html',
    styleUrls: ['./dossier.component.scss']
})
export class DossierComponent implements OnInit {

    @Input()
    dossier: RequeteDetail;

    mandataires: Partie[];
    defendeurs: Partie[];
    requerants: Partie[];
    observateurs: Partie[];
    intervenantsDef: Partie[];
    intervenantsReq: Partie[];

    orderAsc = false;

    constructor(private requeteService: RequeteService,
                private modalService: NgbModal,
                private trackingService: TrackingService,
                private alertService: JhiAlertService,
                ) {

    }

    ngOnInit() {
        this.mandataires = this.filterParties(QualityType.Mandataire);
        this.defendeurs = this.filterParties(QualityType.Defendeur);
        this.requerants = this.filterParties(QualityType.Requerant);
        this.observateurs = this.filterParties(QualityType.Observateur);
        this.intervenantsDef = this.filterParties(QualityType.IntervenantEnDefense);
        this.intervenantsReq = this.filterParties(QualityType.IntervenantEnRequete);
    }

    toggleOrder() {
        this._track(TrackingAction.CLIQUER, 'Inverser ordre chronologique')
        this.dossier.events.reverse();
    }

    canAddPieces() {
        return this.requeteService.canAddPieces(this.dossier);
    }

    private filterParties(qualite: QualityType) {
        return this.dossier.parties.filter(elem => elem.qualite === qualite);
    }

    openRequete() {
        this.dossier.renamed = false;
        this._track(TrackingAction.CLIQUER, 'Renommer votre dossier');
        const modalRef = this.modalService.open(RenameDossierComponent, {size: 'lg'});
        (<RenameDossierComponent>modalRef.componentInstance).dossier = this.dossier;
        this.addSuccessAlert();
    }

    public addSuccessAlert() {
        this.alertService.addAlert({type: 'success', msg: 'historique.messages.success', timeout: 10000}, []);
    }

    public trackAjoutDoc() {
        this._track(TrackingAction.CLIQUER, 'Ajouter des documents complémentaires')
    }

    private _track(action: TrackingAction, name: string) {
      this.trackingService.trackEvent({
        action,
        properties: {
          category: TrackingCategory.CONSULTATION_DOSSIER,
          name: name
        }
      });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/dossier/dossier.component.ts